/* eslint-disable ember/classic-decorator-hooks, ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get */
import { tracked } from '@glimmer/tracking';
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import TransactionType from '@linc-technologies/linced-common/enums/transaction-type';
import moment from 'moment';

const adjustmentFilter = { filter: TransactionType.ADJUSTMENT };

export default class ReportingController extends Controller {
  @action
  setEndDate(value) {
    this.endDate = value;
  }

  @action
  setLedgerFilter(value) {
    this.ledgerFilter = value;
  }

  @action
  setLedgerItemFilter(value) {
    this.ledgerItemFilter = value;
  }

  @action
  setStartDate(value) {
    this.startDate = value;
  }

  @service
  session;

  @service
  router;

  @service
  strings;

  adjustmentFilter = adjustmentFilter;
  @tracked
  startDate = moment().month(0).date(1).format('YYYY-MM-DD');
  @tracked
  endDate = moment().format('YYYY-MM-DD');
  @tracked
  filter = null;

  @computed('session.school.jurisdiction')
  get typeFilters() {
    let filters = [
      {
        filter: TransactionType.PAYMENT,
        label: 'Payments',
      },
      {
        filter: TransactionType.TRANSFER,
        label: 'Transfers',
      },
      {
        filter: TransactionType.REFUND,
        label: 'Refunds',
      },
      {
        filter: TransactionType.DISCOUNT___EXEMPTION,
        label: 'Discounts / Exemptions',
      },
      {
        filter: TransactionType.VOID,
        label: 'Voids',
      },
      {
        filter: TransactionType.WRITEOFF,
        label: 'Write Offs',
      },
      {
        filter: 0,
        label: 'All Transactions',
      },
    ];
    if (this.get('session.school.jurisdiction') === Jurisdiction.AU_NSW) {
      filters.splice(filters.length - 1, 0, {
        filter: TransactionType.PAYMENT,
        label: 'Cancelled Payments',
        cancelled: true,
      });
    }
    return filters;
  }

  @tracked ledgerFilter = '';

  @computed('ledgerFilter', 'model.ledgers.@each.id')
  get filteredLedgers() {
    if (this.ledgerFilter) {
      let filter = this.ledgerFilter.toLowerCase();
      return this.model.ledgers.filter((ledger) => {
        return (
          ledger.code.toLowerCase().match(filter) ||
          ledger.name.toLowerCase().match(filter)
        );
      });
    }
    return this.model.ledgers;
  }

  @tracked ledgerItemFilter = '';

  @computed('ledgerItemFilter', 'model.ledgerItems.@each.id')
  get filteredLedgerItems() {
    if (this.ledgerItemFilter) {
      let filter = this.ledgerItemFilter.toLowerCase();
      return this.model.ledgerItems.filter((item) => {
        return item.name.toLowerCase().match(filter);
      });
    }
    return this.model.ledgerItems;
  }

  init() {
    super.init(...arguments);
    this.filter = this.typeFilters[0];
  }

  @action
  setFilter(filter) {
    this.filter = filter;
  }

  @action
  viewBatchLedger(ledger) {
    const queryParams = {
      from: this.startDate,
      to: this.endDate,
    };
    this.router.transitionTo('admin.reports.finance.batch.ledger', ledger.id, {
      queryParams,
    });
  }

  @action
  viewBatchLedgerItem(ledgerItem) {
    const queryParams = {
      from: this.startDate,
      to: this.endDate,
    };
    this.router.transitionTo(
      'admin.reports.finance.batch.ledger-item',
      ledgerItem.id,
      { queryParams },
    );
  }

  @action
  viewReport(report, filter) {
    const queryParams = {
      from: this.startDate,
      to: this.endDate,
      cancelled: false,
    };
    if (!isEmpty(filter)) {
      queryParams.transactionType = filter.filter;
      if (filter.cancelled) {
        queryParams.cancelled = true;
      }
    }
    this.router.transitionTo(`admin.reports.finance.${report}`, {
      queryParams,
    });
  }
}
